import React from "react";
// const LottieComponent = React.lazy(async () => import("lottie-react"));
import LottieComponent from "lottie-react";

interface LottieVideoProps {
  lottieJSON: string;
  height?: number;
  loop?: boolean;
}

const LottieVideo: React.FC<LottieVideoProps> = ({ lottieJSON, height, loop = false }) => {
  return (
    <LottieComponent
      animationData={lottieJSON}
      loop={loop}
      style={{ height: height ? `${height}px` : "100%", maxHeight: 768 }}
    />
  );
};

export default LottieVideo;
